import { gql } from '@apollo/client';

export const PATIENT_FRAGMENT = gql`
  fragment PatientFragment on Patient {
    id
    avatar
    last_name
    first_name
    date_of_birth
    languages
    gender
    health_info
  }
`;

export const SHARED_FILE_FRAGMENT = gql`
  fragment SharedFileFragment on StorageFile {
    id
    name
    size
    mime
    updated_at
  }
`;

export const SHARED_FOLDER_FRAGMENT = gql`
  fragment SharedFolderFragment on Folder {
    id
    name
    updated_at
  }
`;
